const buttonListener = (button: HTMLButtonElement) => {
  button.addEventListener("click", () => {
    console.log(button.dataset);

    const url = new URL(window.top.location.href);

    url.searchParams.set("variant", button.dataset.variantId || "");

    window.top.location.href = url.toString();
  });
};

const init = () => {
  const optionInputWrappers = document.querySelectorAll(
    "[data-option-buttons]"
  );

  if (!optionInputWrappers) {
    console.log("Option input wrappers not found");
    return;
  }
  optionInputWrappers.forEach((optionInputWrapper) => {
    const buttons = optionInputWrapper.querySelectorAll(
      "[dynamic-variant-button]"
    );
    buttons.forEach((button) => buttonListener(button as HTMLButtonElement));
  });
};

document.readyState === "loading"
  ? document.addEventListener("DOMContentLoaded", init)
  : init();
